<template>
  <div>
   
    <!-- 首页介绍 -->
    <HomeView />
    <!-- 个人信息详细介绍 -->
    <AboutView />
    <!-- 编程项目分享 -->
    <PortfolioView />
    <!-- 摄影分享 -->
    <BlogView />
    <!-- 联系我 -->
    <ContactView/>


  </div>
</template>

<script>
import HomeView from "./HomeView.vue";
import AboutView from "./AboutView.vue";
// import ArticleView from "./ArticleView.vue";
import BlogView from "./BlogView.vue";
import PortfolioView from "./PortfolioView.vue";
import ContactView from "./ContactView.vue";

export default {
  name: 'AllView',
  components: {
    HomeView,
    AboutView,
    ContactView,
    BlogView,
    PortfolioView,

  }
}
</script>

<style></style>
../components/LxBg/LxBg.vue